// ======================================================================
// File Name       : UserList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TableHead, { setSortState } from '../TableHead';
import { USER } from '../../constants/PathConstants';
import { DORMANT_STATE } from '../../constants';
import CustomLink from '../button/CustomLink';
import * as ICON from '../../constants/IconConstants';
import { Col } from 'react-bootstrap';
import PaginationCustom from '../Pagination';

class UserList extends React.Component {
  /**
   * Get management authority name
   *
   * @param {String} managementAuthoritySecernId
   */
  getManagementAuthorityName(managementAuthoritySecernId) {
    for (const managementAuthority of this.props.managementAuthorityList) {
      if (managementAuthority.managementAuthoritySecernId === managementAuthoritySecernId) {
        return managementAuthority.managementAuthorityName;
      }
    }
    return null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const shouldNotUpdate =
    nextProps.searchInfo.userSortType === this.props.searchInfo.userSortType &&
    nextProps.searchInfo.ascendingDescendingSort === this.props.searchInfo.ascendingDescendingSort &&
    nextProps.managementAuthorityList === this.props.managementAuthorityList &&
    nextProps.userList === this.props.userList &&
    nextProps.hoverIndex === this.props.hoverIndex;
    return !shouldNotUpdate;
  }

  render() {
    // table head
    const thead = [
      { title: 'ログインID', sortBy: 1},
      { title: 'ユーザー名', sortBy: 0 },
      { title: 'ロール', sortBy: 2 , width:'10%'},
      { title: 'ユーザーグループ', sortBy: null },
      { title: 'ロック状態', sortBy: 3, width:'5%'},
      { title: '操作', sortBy: null, width:'100'},
    ];
    const { searchInfo, recordNum, getStartEndData, startPosition } = this.props;
    let data = thead;
    if (searchInfo) {
      const sortBy = searchInfo.userSortType;
      const sortState = searchInfo.ascendingDescendingSort;
      data = setSortState(thead, sortBy, sortState);
    }
    // table data
    let userTableData = null;
    if (this.props.userList) {
      userTableData = this.props.userList.map((userInfo, index) => {
        const link = `/${USER}/${userInfo.userSecernId}`;
        return (
          <tr className={userInfo.dormantState == DORMANT_STATE.INACTIVE ? 'inactive-class' : ''} key={index} onMouseEnter={() => this.props.handleMouseEnter(index)} onMouseLeave={() => this.props.handleMouseLeave()}>
            <td>
              <div className="icon-inline">
                <i className="bi bi-person-fill" />
                <div className="margin-left-10"> {userInfo.loginId} </div>
              </div>
            </td>
            <td>{userInfo.userName}</td>
            <td>
              {this.getManagementAuthorityName(userInfo.managementAuthoritySecernId)}
            </td>
            <td>{userInfo.groupNames}</td>
            <td className="text-center">
              {userInfo.lockState ? <i className="bi bi-lock" /> : ''}
            </td>
            <td className="text-center">
              <CustomLink
                className="margin-right-7 link-detail-edit"
                to={link}
                text="詳細"
              />
            </td>
          </tr>
        );
      });
    }

    return <>
      <Table striped hover>
        <thead>
          <TableHead data={data} handleSortState={this.props.handleSortState.bind(this)} />
        </thead>
        <tbody>
          {userTableData}
        </tbody>
      </Table>
      <Col sm={12} className="d-flex justify-content-center">
        <PaginationCustom
          recordNum={recordNum}
          startPosition={startPosition}
          handlePageSelect={getStartEndData}
        />
      </Col>
    </>;
  }
}
export default UserList;
